"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSearchComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="user-search-widget form-group">
  ${(0, fast_element_1.when)(x => x.hasLabel, (0, fast_element_1.html) `<label class="form-label">${'searchUser.users'.t()}${(0, fast_element_1.when)(x => x.isRequired, (0, fast_element_1.html) ` <span class="required-sign">*</span>`)}</label>`)}

  <div class="user-search">
    <input type="text" class="form-control" placeholder="${'searchUser.searchPlaceholder'.t()}" :value="${x => x.searchQuery}"
      @input="${(x, c) => x.onSearchInput(c.event)}"
      @focus="${x => x.onSearchFocus()}"
      @blur="${x => x.onSearchBlur()}"
      @keyup="${(x, c) => c.event.key === 'Enter' && x.searchUsers()}" />
    
    <div class="users-dropdown"
      ?hidden="${x => !x.showUsersDropdown || x.filteredUsers.length === 0}">
      ${(0, fast_element_1.repeat)(x => x.filteredUsers, (0, fast_element_1.html) `
      <div class="user-item ${(x, c) => c.parent.isUserSelected(x) ? 'selected' : ''}"
        @click="${(x, c) => c.parent.onUserSelect(x)}">
        <div class="user-info">
          <div class="user-avatar">
            <i class="icon-person"></i>
          </div>
          <div class="user-details">
            <div class="user-name">${x => x.name}</div>
            <div class="user-username">@${x => x.username}</div>
          </div>
        </div>
        <div class="selection-indicator">
          <i class="${(x, c) => c.parent.isUserSelected(x) ? 'icon-check-circle' : 'icon-circle-o'}"></i>
        </div>
      </div>
      `)}
    </div>
  </div>

  <div class="selected-users" ?hidden="${x => x.selectedUsers.length === 0}">
    <div class="selected-users-header">
      <span>${'searchUser.selectedParticipants'.t()} (${x => x.selectedUsers.length})</span>
    </div>
    <div class="selected-users-list">
      ${(0, fast_element_1.repeat)(x => x.selectedUsers, (0, fast_element_1.html) `
      <span class="user-tag">
        ${x => x.name}
        <button type="button" class="remove-user" @click="${(x, c) => c.parent.toggleUserSelection(x)}">
          <i class="simple-icon-close"></i>
        </button>
      </span>`)}
    </div>
  </div>

  <div class="empty-users" ?hidden="${x => x.showUsersDropdown || x.filteredUsers.length > 0 || x.searchQuery.trim() === ''}">
    <p class="text-muted">${'searchUser.noUsersFound'.t()}</p>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  position: relative;
}

.user-search-widget {
  position: relative;
}
.user-search-widget .form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
}
.user-search-widget .form-label .required-sign {
  color: #dc3545;
  margin-left: 0.25rem;
}
.user-search-widget .user-search {
  position: relative;
  margin-bottom: 1rem;
}
.user-search-widget .user-search .form-control {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  font-size: 1rem;
  line-height: 1.5;
  background-color: #fff;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.user-search-widget .user-search .form-control:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.user-search-widget .user-search .form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.user-search-widget .users-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.user-search-widget .users-dropdown .user-item {
  padding: 0.75rem;
  border-bottom: 1px solid #f8f9fa;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-search-widget .users-dropdown .user-item:hover {
  background-color: #f8f9fa;
}
.user-search-widget .users-dropdown .user-item:last-child {
  border-bottom: none;
}
.user-search-widget .users-dropdown .user-item.selected {
  background-color: #e7f3ff;
  border-left: 3px solid #007bff;
}
.user-search-widget .users-dropdown .user-item .user-info {
  display: flex;
  align-items: center;
  flex: 1;
}
.user-search-widget .users-dropdown .user-item .user-info .user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  color: white;
  font-size: 1rem;
}
.user-search-widget .users-dropdown .user-item .user-info .user-avatar i {
  font-size: 1rem;
}
.user-search-widget .users-dropdown .user-item .user-info .user-details {
  flex: 1;
}
.user-search-widget .users-dropdown .user-item .user-info .user-details .user-name {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.125rem;
  font-size: 0.875rem;
}
.user-search-widget .users-dropdown .user-item .user-info .user-details .user-username {
  font-size: 0.75rem;
  color: #6c757d;
}
.user-search-widget .users-dropdown .user-item .selection-indicator {
  margin-left: 0.5rem;
  color: #007bff;
}
.user-search-widget .users-dropdown .user-item .selection-indicator i {
  font-size: 1.2rem;
}
.user-search-widget .selected-users {
  margin-bottom: 1rem;
}
.user-search-widget .selected-users .selected-users-header {
  margin-bottom: 0.5rem;
}
.user-search-widget .selected-users .selected-users-header span {
  font-weight: 500;
  color: #495057;
  font-size: 0.875rem;
}
.user-search-widget .selected-users .selected-users-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  min-height: 40px;
  padding: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  background-color: #f8f9fa;
}
.user-search-widget .selected-users .selected-users-list .user-tag {
  display: inline-flex;
  align-items: center;
  background-color: #007bff;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}
.user-search-widget .selected-users .selected-users-list .user-tag .remove-user {
  background: none;
  border: none;
  color: white;
  font-size: 1em;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  margin-left: 0.5rem;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.user-search-widget .selected-users .selected-users-list .user-tag .remove-user:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.user-search-widget .selected-users .selected-users-list .user-tag .remove-user i {
  font-size: 0.75rem;
}
.user-search-widget .selected-users .selected-users-list:empty::before {
  content: "No users selected";
  color: #6c757d;
  font-style: italic;
  font-size: 0.875rem;
}
.user-search-widget .empty-users .text-muted {
  color: #6c757d;
  font-style: italic;
  text-align: center;
  padding: 1rem;
  margin: 0;
}`;
const shadowOptions = { "mode": "open" };
let UserSearchComponent = class UserSearchComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.error = null;
        this.availableUsers = [];
        this.selectedUsers = [];
        this.searchQuery = '';
        this.showUsersDropdown = false;
        this.required = 'false';
        this.hasLabel = true;
        this.isRequired = false;
        this.onPick = (pickedUsers) => { };
        this.searchTimeout = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.loadAvailableUsers();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }
    requiredChanged(newValue) {
        this.isRequired = newValue === 'true';
    }
    async loadAvailableUsers() {
        try {
            const routeOptions = {
                queryParams: {
                    per_page: '10',
                    page: '1'
                },
                routeParams: {}
            };
            if (this.searchQuery.trim()) {
                routeOptions.routeParams.q = this.searchQuery.trim();
            }
            const response = await this.apiService.back.get('user.list', routeOptions);
            if (response && response.success) {
                this.availableUsers = response.data;
            }
        }
        catch (error) {
            console.error('Error loading users:', error);
            this.notifyService.notify('searchUser.failedToLoadUsers'.t(), 'error');
        }
    }
    // Toggle selection by IUser object
    toggleUserSelection(user) {
        const index = this.selectedUsers.findIndex(u => u.id === user.id);
        if (index > -1) {
            this.selectedUsers.splice(index, 1);
        }
        else {
            this.selectedUsers.push(user);
        }
        this.selectedUsers = [...this.selectedUsers];
        this.onPick(this.selectedUsers);
    }
    // Check if user is selected by IUser object
    isUserSelected(user) {
        return this.selectedUsers.some(u => u.id === user.id);
    }
    async searchUsers() {
        await this.loadAvailableUsers();
    }
    onSearchInput(event) {
        const target = event.target;
        this.searchQuery = target.value;
        // Clear existing timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        // Debounce search
        this.searchTimeout = setTimeout(() => {
            this.loadAvailableUsers();
        }, 300);
        // Show dropdown when typing
        this.showUsersDropdown = true;
    }
    onSearchFocus() {
        this.showUsersDropdown = true;
        // Load users if not already loaded or if we need to refresh
        if (this.availableUsers.length === 0 || !this.searchQuery.trim()) {
            this.loadAvailableUsers();
        }
    }
    onSearchBlur() {
        // Delay hiding to allow clicks on dropdown items
        setTimeout(() => {
            this.showUsersDropdown = false;
        }, 150);
    }
    onUserSelect(user) {
        this.toggleUserSelection(user);
        this.showUsersDropdown = false;
        this.searchQuery = '';
    }
    get filteredUsers() {
        if (!this.searchQuery.trim()) {
            return this.availableUsers;
        }
        const query = this.searchQuery.toLowerCase();
        return this.availableUsers.filter(user => user.name.toLowerCase().includes(query) ||
            user.username.toLowerCase().includes(query));
    }
};
exports.UserSearchComponent = UserSearchComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], UserSearchComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], UserSearchComponent.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], UserSearchComponent.prototype, "availableUsers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], UserSearchComponent.prototype, "selectedUsers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], UserSearchComponent.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], UserSearchComponent.prototype, "showUsersDropdown", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], UserSearchComponent.prototype, "required", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], UserSearchComponent.prototype, "hasLabel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], UserSearchComponent.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], UserSearchComponent.prototype, "onPick", void 0);
exports.UserSearchComponent = UserSearchComponent = __decorate([
    (0, client_1.RWSView)('user-search-component', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], UserSearchComponent);
UserSearchComponent.defineComponent();
